<template>
	<div class="ui form" id="patient-profile-form">

    <div class="ui positive message" id="update-patient-success" style="display: none;">
      <i class="green checkmark icon"></i>
        Patient information updated successfully!
    </div>

    <div class="ui negative message" id="update-patient-failed" style="display: none;">
      <i class="red exclamation icon"></i>
      Sorry, something went wrong. Please try again!
    </div>

    <div class="required four wide field">
      <label>Medgate ID</label>
      <input id="medgate-id"
             name="medgate-id"
             type="number"
             v-model="data.medgateId">
    </div>

    <div class="required four wide field">
      <label>Patient Name</label>
      <input id="patient-name" name="patient-name" type="text"
             v-model="data.name">
    </div>

    <div class="field">
      <label>Language</label>
      {{ inheritedPatient.data.language }}
    </div>

    <div class="field">
      <label>Employer Program Consent</label>
      <i v-if="consent===true" class="green checkmark icon"></i>
      <i v-else class="red close icon"></i>
    </div>

    <div class="required field">
      <label>Objective(s)</label>
      <select id="patient-objective" name="patient-objective" class="ui fluid search dropdown" multiple
              v-model="data.objective">
        <option value="Relationship with HCP">Relationship with HCP</option>
        <option value="Migraine Attacks">Migraine Attacks</option>
        <option value="Lifestyle Changes">Lifestyle Changes</option>
        <option value="Social Aspects">Social Aspects</option>
        <option value="Migraine at Work">Migraine at Work</option>
        <option value="Other">Other</option>
      </select>
    </div>

    <div class="required six wide field">
      <label><b>Program Enrollment Date</b></label>
      <div id="coaching-start-date"></div>
    </div>

    <div class="six wide field">
      <label><b>Program Completion Date</b></label>
      <div class="ui calendar" id="program-completion-date">
        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="coaching-end-date" name="coaching-end-date" type="text" placeholder="Date">
        </div>

      </div>
    </div>

    <div class="eight wide field">
      <label>Next Telemedicine Doctor Appointment</label>
      <span v-if="data.docAppt.reschedule === true"><i class="red exclamation circle icon"></i><i>Request to Reschedule</i></span>
      <div class="ui calendar appointment" >

        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="next-doctor-appointment" name="next-doctor-appointment" type="text" placeholder="Date/Time">
        </div>
      </div>
    </div>

    <div class="eight wide field">
      <label>Next Telemedicine Nurse Appointment</label>
      <span v-if="data.coachAppt.reschedule === true"><i class="red exclamation circle icon"></i><i>Request to Reschedule</i></span>
      <div class="ui calendar appointment">
        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="next-nurse-appointment" name="next-nurse-appointment" type="text" placeholder="Date/Time">
        </div>
      </div>
    </div>

    <div class="field">
      <label>Notes</label>
      <quill-editor v-model="data.coachNotes"></quill-editor>
    </div>

    <div class="ui primary submit button"
         :class="{ disabled: loadingState}"
         @click="updatePatientProfile" >
      <span v-if="loadingState === false">Update Patient Details</span>
      <span v-if="loadingState === true">Updating Patient Details &nbsp;&nbsp;&nbsp;<i class="ui loading spinner icon"></i></span>
    </div>
  </div>
</template>

<script>
	export default {
	  props: {
	    inheritedPatient: {
	      type: Object,
        required: true
      },
      userId: {
	      required: true
      },
      consent: {
	      type: Boolean,
        required: true
      }
    },
		data() {
			return {
			  planId: this.inheritedPatient.id,
        data: {
          name: this.inheritedPatient.data.name,
          language: this.inheritedPatient.data.language,
          lastSeenTime: this.inheritedPatient.data.lastSeenTime, //UNIX Timestamp
          startDate: this.inheritedPatient.data.startDate, //UNIX Timestamp (UTC 00:00:00)
          endDate: this.inheritedPatient.data.endDate, //defaults to null until the user exits?
          objective: this.inheritedPatient.data.objective,
          coachNotes: this.inheritedPatient.data.coachNotes,
          medgateId: this.inheritedPatient.data.medgateId, //this is purely MedGate
          docAppt: {
            timestamp: this.inheritedPatient.data.docAppt.timestamp, //defaults to null if it doesn't exists. UNIX or YYYY-MM-DD
            reschedule: this.inheritedPatient.data.docAppt.reschedule //defaults to false when created
          },
          coachAppt: {
            timestamp: this.inheritedPatient.data.coachAppt.timestamp, //defaults to null if it doesn't exists. UNIX or YYYY-MM-DD
            reschedule: this.inheritedPatient.data.coachAppt.reschedule
          },
          consent: {
            coachingConsent: this.inheritedPatient.data.consent.coachingConsent, //default to false
            studyConsent: this.inheritedPatient.data.consent.studyConsent, //default to false
          },
          coachMessage: {
            title: this.inheritedPatient.data.coachMessage.title,
            body: this.inheritedPatient.data.coachMessage.body,
            lastModifiedTime: this.inheritedPatient.data.coachMessage.lastModifiedTime //UNIX Timestamp real-time
          },
          dailyTracking: this.inheritedPatient.data.dailyTracking,
          oneTimeTracking: this.inheritedPatient.data.oneTimeTracking,
          notTrackable: this.inheritedPatient.data.notTrackable,
          lastModifiedTime: this.inheritedPatient.data.lastModifiedTime,
          lastModifiedByUser: this.inheritedPatient.data.lastModifiedByUser,
          deletedStatus: false,
        },
        loadingState: false
      }
		},
		computed: {

    },
		methods: {

      constructUpdatedPatient() {
        // Note: Super weird and hackish constructor because we're using Semantic UI Calendar
        // Only the dates need to grab from document.querySelector. Everything else should have been emitted
        // This grabs all the time related inputs when "Save Patient Details" is pressed
        this.data.docAppt.timestamp = document.getElementById('next-doctor-appointment').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('next-doctor-appointment').value), true, true) : null;
        this.data.coachAppt.timestamp = document.getElementById('next-nurse-appointment').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('next-nurse-appointment').value), true, true) : null;
        this.data.endDate = document.getElementById('coaching-end-date').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('coaching-end-date').value)) : null;

        //TODO: Fix this as this is buggy! the reschedule gets set as false even though everything is working!
        //This part checks if the value has changed. If changed, then reset reschedule as false.
        if ( this.data.docAppt.timestamp !== this.inheritedPatient.data.docAppt.timestamp ) {
          this.data.docAppt.reschedule = false;
        }
        if ( this.data.coachAppt.timestamp !== this.inheritedPatient.data.coachAppt.timestamp ) {
          this.data.coachAppt.reschedule = false;
        }
        // Constructs updated Patient data SANS userPlans
        let patientProfileData = {
          id: this.planId,
          planType: "profile",
          attribute: "NVSDemoCoaching",
          data: {}
        };
        patientProfileData.data = JSON.parse(JSON.stringify(this.data));
        return patientProfileData;

      },
      initFormValidation: function() {
        $('#patient-profile-form').form({
          fields: {
            'medgate-id': {
              identifier: 'medgate-id',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
            'patient-name': {
              identifier: 'patient-name',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
            'patient-objective': {
              identifier: 'patient-objective',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },

            //TODO: Validate that end date can not be before start date?
          },
          inline: true,
          keyboardShortcuts: false
        });
      },
      updatePatientProfile(){
        $('#update-patient-failed').css('display','none');
        $('#update-patient-success').css('display','none');

        let validationStatus = $('#patient-profile-form').form('is valid');
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsers/' + this.userId + '/userPlans';

        if (validationStatus === true) {
          this.loadingState = true;
          this.$http.put(requestUrl, [this.constructUpdatedPatient()]).then( (response) => {
            window.location.reload();
            window.scrollTo(0,0);
            $('#update-patient-success').css('display','block');
            this.loadingState = false;
          }, (error) => {
            if (error.status === 401) {
              this.loadingState = false;
              this.clearAllSessionData({ errorStatusCode: 401 });
            }
            else{
              $('#update-patient-failed').css('display','block');
              Rollbar.error("Failed update patient profile plan", error);
            }
          });
        }
        else {
          $('#patient-creation-form').form('validate form');
        }
      }
    },
    mounted(){

      //TODO: Convert + validate doctor and nurse appointment entries

      $('.ui.dropdown').dropdown();
      $('#program-completion-date').calendar({
        type: 'date',
        minDate: new Date(this.data.startDate)
      });
      $('.ui.calendar.appointment').calendar({
        minDate: new Date(),
      });

      let dateOptions = { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' };

      document.getElementById('coaching-start-date').innerHTML = new Date(this.data.startDate).toLocaleDateString('en-US', dateOptions);
      if (this.data.endDate !== null && this.data.endDate !== 0 ) {
        document.getElementById('coaching-end-date').value = new Date(this.data.endDate).toLocaleDateString('en-US', dateOptions);
      }

      let apptOptions = { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
      // Note: .replace to account for the weird space as a result of toLocalDateStrin
      // REF: https://stackoverflow.com/questions/21413757/tolocaledatestring-changes-in-ie11
      if (this.data.docAppt.timestamp !== null && this.data.docAppt.timestamp !== 0 ) {
        document.getElementById('next-doctor-appointment').value = new Date(this.data.docAppt.timestamp).toLocaleDateString('en-US', apptOptions).replace(/[^ -~]/g,'');
      }
      if (this.data.coachAppt.timestamp !== null && this.data.coachAppt.timestamp !== 0 ) {
        document.getElementById('next-nurse-appointment').value = new Date(this.data.coachAppt.timestamp).toLocaleDateString('en-US', apptOptions).replace(/[^ -~]/g,'');
      }

      this.initFormValidation();
    }
	}
</script>

<style scoped>
  .ui.popup.calendar.bottom.left.transition.visible {
    z-index: 99 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/patients/PatientProfileEdit.vue